
import { all } from 'redux-saga/effects';
import { watchAuth } from '../sagas/Auth/Auth';
import { User,Communitys,Tenant,Discalimer,RegistrationFee,MaintenanceSaga } from './index';


export default function* rootSaga() {
  yield all([
    watchAuth(),
    User(),
    Communitys(),
    Tenant(),
    Discalimer(),
    RegistrationFee(),
    MaintenanceSaga(),
  ]);
}
